import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import axiosInstance from "../utils/axiosConfig";

export default function ProtectedRoute({ children }) {
  const [isValid, setIsValid] = useState(null);

  useEffect(() => {
    const checkToken = async () => {
      const token = localStorage.getItem("Token");
      if (!token) {
        setIsValid(false);
        return;
      }

      try {
        // If refresh-token already invalid → 401 → logout
        await axiosInstance.post("/auth/verify-token/", { token });  
        setIsValid(true);
      } catch (err) {
        localStorage.removeItem("Token");
        localStorage.removeItem("Email");
        setIsValid(false);
      }
    };

    checkToken();
  }, []);

  if (isValid === null) return null; // optional loader can go here
  return isValid ? children : <Navigate to="/login" />;
}
